import { observable, action } from 'mobx'
import { identifier, serializable, list } from 'serializr'
import { v4 } from 'uuid'

class Query {
  @serializable(identifier())
  id

  @serializable
  @observable
  term

  @serializable(list())
  @observable
  species

  @serializable
  @observable
  caller

  constructor(term = '', species = [], caller = '') {
    this.id = v4()
    this.setTerm(term)
    this.setSpecies(species)
    this.setCaller(caller)
  }

  @action
  setTerm = (term) => (this.term = term)
  @action
  setSpecies = (species) => (this.species = species)
  @action
  setCaller = (caller) => (this.caller = caller)
}

export default Query
